"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var SectionLoader = function () { return (<core_1.Box width={'100%'} data-test={'section:loader'}>
    <core_1.Box display="flex" justifyContent="space-between" alignItems="center">
      <lab_1.Skeleton animation="wave" height={42} width="45%"/>
      <core_1.Box style={{ width: 27, height: 27 }}>
        <lab_1.Skeleton animation="wave" variant="circle" height={27}/>
      </core_1.Box>
    </core_1.Box>
    <lab_1.Skeleton animation="wave" height={35} width="85%"/>
    <lab_1.Skeleton animation="wave" height={35} width="85%"/>
    <lab_1.Skeleton animation="wave" height={35} width="85%"/>
  </core_1.Box>); };
exports.default = SectionLoader;
